module.exports = __webpack_public_path__ + "static/media/traffic-light.5b7375ae.svg";